<template>
  <v-dialog
    v-model="bookOutDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="bookOutDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>מסירה</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="loading"
          :disabled="loading"
          @click="bookOut"
        >
          ביצוע מסירה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-alert
          prominent
          type="info"
          v-if="isWrongBookOutDate"
        >
          תאריך האיסוף לא תואם את ההזמנה.
        </v-alert>
      </v-card-text>
      <v-card-text class="pt-0">
        <v-text-field
          label="IMEI"
          v-model="editableResource.imei"
        ></v-text-field>
        <v-textarea
          v-model="editableResource.customerComments"
          label="הערות לקוח"
          :rows="2"
        ></v-textarea>
        <v-textarea
          v-model="editableResource.agentComments"
          label="הערות נציג"
          :rows="2"
        ></v-textarea>
      </v-card-text>
      <v-card-text>
        <h3 class="title black--text">פרטי נציג</h3>
        <v-text-field
          label="מזהה נציג"
          v-model="editableResource.agentId"
        ></v-text-field>
        <v-select
          :items="lametayelStores"
          item-value="_id"
          item-text="title"
          label="חנות"
          v-model="editableResource.agentStore"
        ></v-select>
      </v-card-text>
      <v-card-text>
        <h3 class="title black--text">פעולות נלוות</h3>
        <v-checkbox
          v-model="editableResource.sendMessagesToCustomers"
          color="primary"
          :label="`שליחת הודעות ללקוח`"
        ></v-checkbox>
        <v-checkbox
        class="mt-0"
          v-model="editableResource.createTasks"
          color="primary"
          :label="`יצירת משימות`"
        ></v-checkbox>
        <v-checkbox
        class="mt-0"
          v-model="editableResource.doStoreTransfer"
          color="primary"
          :label="`ביצוע העברת חנות למכשיר`"
        ></v-checkbox>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import { differenceInCalendarDays } from "date-fns";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      loading: false,
      editableResource: {}
    };
  },

  computed: {
    bookOutDialog: {
      get() {
        return this.$store.state.bookOutDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_BOOK_OUT_DIALOG", isActive);
      }
    },
    order() {
      return this.$store.state.entities.orders[this.orderId];
    },
    isWrongBookOutDate() {
      if (this.order) {
        let orderStartDate = this.order.startDate;
        return (
          differenceInCalendarDays(new Date(), new Date(orderStartDate)) != 0
        );
      }
      return false;
    },
    lametayelStoreType() {
      let lametayelStoreType = Object.values(
        this.$store.state.entities.storeTypes
      ).find(item => {
        return item.key === "LAMETAYEL";
      });
      if (lametayelStoreType) {
        return lametayelStoreType._id;
      }
      return null;
    },
    lametayelStores() {
      return this.$store.getters["entityList"]("stores").filter(item => {
        return item.type === this.lametayelStoreType;
      });
    }
  },

  methods: {
    bookOut() {
      this.loading = true;

      getApi()
        .then(api => {
          let params = {
            imei: this.editableResource.imei,
            agentId: this.editableResource.agentId,
            agentStore: this.editableResource.agentStore,
            agentComments: this.editableResource.agentComments,
            customerComments: this.editableResource.customerComments,
            sendMessagesToCustomers: this.editableResource.sendMessagesToCustomers,
            createTasks: this.editableResource.createTasks,
            doStoreTransfer: this.editableResource.doStoreTransfer,
          };
          return api.post(`/orders/${this.orderId}/book-out`, params);
        })
        .then(() => {
          this.bookOutDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "המסירה הושלמה בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initEditableResource() {
      this.editableResource = {
        sendMessagesToCustomers: true,
        createTasks: true,
        doStoreTransfer: true
      }
    }
  },

  mounted() {
    this.initEditableResource();
  },

  props: ["orderId"],

  mixins: [Mixins],

  watch: {
    bookOutDialog: {
      handler: function(val) {
        if (!val) {
          this.initEditableResource();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
